(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  if (window.cookieconsent) {
		var $body = $('body');
		window.cookieconsent.initialise({
		  'palette': {
  			'popup': {
  			  'background': '#4e5663',
  			  'text': '#ffffff'
  			},
  			'button': {
  			  'background': '',
  			  'text': '#ffffff'
  			}
		  },
		  'theme': 'classic',
		  'revokable': true,
		  'type': 'opt-out',
		  'content': {
  			'message': $body.data('cookie-consent-message'),
  			'dismiss': $body.data('cookie-consent-accept'),
  			'deny': $body.data('cookie-consent-deny'),
  			'link': $body.data('cookie-consent-link'),
  			'href': $body.data('cookie-consent-href')
		  },
		  onStatusChange: function() {
        window.location = window.location.href;
		  },
		  'compliance': {
  			'info': "<div class='cc-compliance'>{{dismiss}}</div>",
  			'opt-in': "<div class='cc-compliance cc-highlight'>{{dismiss}}{{allow}}</div>",
  			'opt-out': "<div class='cc-compliance cc-highlight'>{{dismiss}}{{deny}}</div>"
		  },
		  'revokeBtn': "<div class='cc-revoke {{classes}}'>" + $body.data('cookie-consent-policy') + "</div>"
		});
  }
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_cookie.js","/")